export const STATE = {
  LAUNCH: 'LAUNCH',
  INTERVENTION: 'INTERVENTION',
  FINISH: 'FINISH'
};
export const HANDLE_STATE = {
  TO_HANDLE: 'TO_HANDLE',
  HANDLING: 'HANDLING',
  HANDLED: 'HANDLED',
  CANCELLED: 'CANCELLED',
  REJECT: 'REJECT'
};
export const HANDLE_STATE_ZH = {
  TO_HANDLE: '平台待处理',
  HANDLING: '平台处理中',
  HANDLED: '平台已处理',
  CANCELLED: '买家已撤销',
  REJECT: '平台已驳回'
};
export const ORDER_STATUS = {
  TOPAY: 'TOPAY',
  TOSHIP: 'TOSHIP',
  PARTSHIPPED: 'PARTSHIPPED',
  SHIPPED: 'SHIPPED',
  CONFIRMED: 'CONFIRMED',
  REFUNDED: 'REFUNDED',
  CANCELED: 'CANCELED'
};
export const ORDER_STATUS_ZH = {
  TOPAY: '待支付',
  TOSHIP: '待发货',
  PARTSHIPPED: '部分已发货',
  SHIPPED: '已发货',
  CONFIRMED: '已签收',
  REFUNDED: '已退款',
  CANCELED: '已取消订单'
};
export const COMPLAINT_TYPE = {
  SPUDESCRIBENOTMATCH: 'SPUDESCRIBENOTMATCH',
  SUSPECTEDINFRINGEMENT: 'SUSPECTEDINFRINGEMENT',
  SUSPECTEDOFBREAKINGLAW: 'SUSPECTEDOFBREAKINGLAW',
  SALEOFCOUNTERFEITGOODS: 'SALEOFCOUNTERFEITGOODS',
  OTHER: 'OTHER'
};
export const COMPLAINT_TYPE_ZH = {
  SPUDESCRIBENOTMATCH: '商品与描述不符',
  SUSPECTEDINFRINGEMENT: '涉嫌侵权',
  SUSPECTEDOFBREAKINGLAW: '涉嫌违法',
  SALEOFCOUNTERFEITGOODS: '售假',
  OTHER: '其他'
};
